<template>
  <div class="FilterStatus">
    
    <div v-if="filterInfo.length" class="pl-3 ml-3 pr-2 py-3">
      <div v-if="missingOption" class="text-red mb-2">
        Voor iedere eigenschap moet minstens 1 optie actief zijn.
      </div>
      <ul class="FilterStatus__ActiveFilters list-unstyled w-100">
        <li v-for="filter in filterInfo" :key="filter.id" class="mb-3 w-100">
          <div class="d-flex justify-content-between align-items-center font-weight-bold mb-2 w-100">
            <span>{{ filter.label }}</span>

            <b-button size="sm" class="font-weight-normal"  @click="$emit('select', { filter })">
              Wijzigen
            </b-button>
            <!-- <span class="font-weight-normal">Wijzigen</span> -->
          </div> 
          <div class="mr-1 mb-1" v-for="item in filter.active" :key="item.label">{{ item.label }}</div>
        </li>
      </ul>
    </div>
    
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'FilterStatus',
  computed: {
    ...mapGetters('filters', [
      'getFilterInfo',
      'getActiveFilters'
    ]),
    filterInfo() {
      return Object.values(this.getFilterInfo({ mode: null }))
        .filter(item => item.component && item.enabled)
        // .filter(item => item.id !== 'bouwblok' && item.id !== 'bouwblok-auto' && item.id !== 'barcode')
        .map(item => {
          item.active = item.items.slice().filter(item => item.active)
          return item
        }) //.filter(item => item.active.length)
    },
    missingOption() {
      return this.filterInfo.some(list => list.active.length === 0)
    }
  }
}
</script>

<style lang="scss">

.FilterStatus {
  width: 100%;
  overflow-y: scroll;

  ul li {
    line-height: 1
  }

  span {
    cursor: pointer;

    &:hover {
      color: darken(#7a99ac, 20%)
    }
  }
}
</style>